import { combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';
import type { NpsInfo } from 'v2/interfaces/nps';

import apiService from './api';
import type { ApiService } from './api';
import eduzzAccountsService from './eduzzAccount';
import type { EduzzAccountsService } from './eduzzAccount';

class NpsService {
  private readonly siteId = 845988;

  constructor(
    private readonly apiService: ApiService,
    private readonly eduzzAccountsService: EduzzAccountsService
  ) {}

  public getInfo(journey: string) {
    return combineLatest([
      this.apiService.get<NpsInfo>('/nps/info', { journey }),
      this.eduzzAccountsService.getUser()
    ]).pipe(
      map(([info, user]) => ({
        ...info,
        name: user?.name
      }))
    );
  }

  public async getSurveyLastAnswer(surveyId: number) {
    return this.apiService
      .get('/nps/last-answer', {
        site_id: this.siteId,
        survey_id: surveyId
      })
      .toPromise();
  }
}

export const npsService = new NpsService(apiService, eduzzAccountsService);
